import { fromJS } from 'immutable'

const InitialState = fromJS({
  reset: false,
  targetSt: 0,
  prevSt: 0,
  saveSt: 0,
  st: 0,
  ph: 0,
  isScrollEnd: false,
  pageExit: false,
  pageExitComplete: false,
  pageEnter: false,
  pageEnterComplete: false
})

export default function createPageWithNamedType(pageName = '') {
  return function pager(state = InitialState, action) {
      switch (action.type) {
        case `ENTER_${pageName}`:
          // console.log(`ENTER_${pageName}`)
          return state
            .set('pageExit', false)
            .set('pageExitComplete', false)
            .set('pageEnter', true)
            .set('pageEnterComplete', false)
        case `ENTER_COMPLETE_${pageName}`:
          // console.log(`ENTER_COMPLETE_${pageName}`)
          return state
            .set('pageEnter', false)
            .set('pageEnterComplete', true)
        case `EXIT_${pageName}`:
          // console.log(`EXIT_${pageName}`)
          return state
            .set('pageExit', true)
            .set('pageExitComplete', false)
        case `EXIT_COMPLETE_${pageName}`:
          // console.log(`EXIT_COMPLETE_${pageName}`)
          return state
            .set('pageEnterComplete', false)
            .set('pageExit', false)
            .set('pageExitComplete', true)
        case `SAVE_ST_${pageName}`:
          return state.set('saveSt', action.payload)
        case `UPDATE_ST_${pageName}`:
          const prevSt = state.get('st')
          return state
            .set('prevSt', prevSt)
            .set('st', action.payload)
        case `UPDATE_PH_${pageName}`:
          return state.set('ph', action.payload)
        case `SET_PAGE_SCROLL_END_${pageName}`:
          return state.set('isScrollEnd', action.payload)
        case `SET_PAGE_SCROLL_${pageName}`:
          return state
            .set('targetSt', action.payload)
            .set('reset', true)
        case `UNSET_PAGE_SCROLL_${pageName}`:
          return state.set('reset', false)
        default:
          return state
      }
  }
}



// WEBPACK FOOTER //
// ./src/components/create-page/create-page-reducer.js